
/**
 *  Configuration de la modal
 */
export function defaultConfigModal(height: string, top: string, width: string): { height: string, top: string, xs: string, sm: string,
    md: string, ls: string, xl: string} {

    let xs: string = '';
    let sm: string = '';
    let md: string = '';
    let ls: string = '';
    let xl: string = '';

    // configuration de la hauteur
    height = height === null || height === undefined ?
    'auto' :
    height  === 'Large' ? height = '80%' :
    height  === 'Medium' ? height = '60%' :
    height  === 'Small' ? height = '40%' : height;

    // configuration du margin top
    if (top === null || top === undefined) {
        top = 'center';
    }

  // configuration de la width
  const colsExist: boolean = width !== null && width !== undefined && width.includes('col');

    if (colsExist) {
        const w: Array<string> = width.split(' ');
        if (w.length > 0) {
          for (const cols of w) {
              if (cols.includes('col')
              && !cols.includes('col-sm')
              && !cols.includes('col-md')
              && !cols.includes('col-ls')
              && !cols.includes('col-xl')
              ) {
              xs = cols;
              } else if (cols.includes('col-sm')) {
              sm = cols;
              } else if (cols.includes('col-md')) {
              md = cols;
              } else if (cols.includes('col-ls')) {
              ls = cols;
              } else if (cols.includes('col-xl')) {
              xl = cols;
              }
           }
        }
    } else {
      if (width === '' || width === null || width === undefined) {
          xs = 'col-10';
          sm = 'col-sm-10';
          md = height === 'Large' ? 'col-md-8' :
          height === 'Medium' || height === 'auto' ? 'col-md-6' :
          height === 'Small' ? 'col-md-4' : 'col-md-6';
          ls = height === 'Large' ? 'col-ls-9' :
          height === 'Medium' || height === 'auto' ? 'col-ls-7' :
          height === 'Small' ? 'col-ls-3' : 'col-ls-7';
          xl = height === 'Large' ? 'col-xl-10' :
          height === 'Medium' || height === 'auto' ? 'col-xl-8' :
          height === 'Small' ? 'col-xl-4' : 'col-xl-8';
      }
  }

  return {
      height,
      top,
      xs,
      sm,
      md,
      ls,
      xl
  };
}

